/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import MsDyn365 from '@msdyn365-commerce/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

/**
 * CittaTelemetry
 */
export default class CittaTelemetry {
    private cittaInstrumentationKey: string;
    private static appInsights: ApplicationInsights;
    /**
     * Creates a new instance of Telemetry.
     */
    public constructor(cittaInstrumentationKey: string) {
        this.cittaInstrumentationKey = cittaInstrumentationKey;
        if (!CittaTelemetry.appInsights && MsDyn365.isBrowser) {
            CittaTelemetry.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: cittaInstrumentationKey,
                    enableCorsCorrelation: true,
                    // @ts-ignore -- fetching globally available properties
                    correlationHeaderDomains: window._loggerProps[0].correlationHeaderDomains
                }
            });

            CittaTelemetry.appInsights.loadAppInsights();
        }
    }

    public trace = (message: string, ...args: unknown[]): void => {
        try {
            if (MsDyn365.isBrowser) {
                // @ts-ignore
                if (this.cittaInstrumentationKey && window) {
                    CittaTelemetry.appInsights.trackTrace({
                        message: message,
                        severityLevel: 1
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    public exception = (error: Error, message: string, ...args: unknown[]): void => {
        try {
            if (MsDyn365.isBrowser) {
                console.log('message', message);
                // @ts-ignore
                if (this.cittaInstrumentationKey && window) {
                    CittaTelemetry.appInsights.trackTrace(error, {message: message});
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
}